/** Auth headers every mapping endpoint expects. */
export const authHeaders = () => ({
    authorization: `Bearer ${window.localStorage.getItem('accessToken')}`,
    'content-type': 'application/json'
})

export const asArray = (data) => (Array.isArray(data) ? data : [])

export const asText = (value) => (value == null ? '' : String(value))

/**
 * Mapping endpoints return either plain strings or { name, value } objects.
 * Normalises both into the { value, label } shape the shared select expects,
 * dropping blanks and de-duplicating on value.
 */
export const toSelectOptions = (data) => {
    const seen = {}
    return asArray(data)
        .map((item) => {
            if (item && typeof item === 'object') {
                const value = asText(item.value != null ? item.value : item.name)
                return { value, label: asText(item.name != null ? item.name : item.value) || value }
            }
            const value = asText(item)
            return { value, label: value }
        })
        .filter((option) => {
            if (option.value === '' || seen[option.value]) {
                return false
            }
            seen[option.value] = true
            return true
        })
}
